module.exports = __webpack_public_path__ + "img/clq.6d986a4c.png";